import * as classnames from 'classnames'
import * as React from 'react'
import * as styles from './infoModal.module.css'

import CheckIcon from '../../icons/ok'

interface IProps {
  closeModal: any
}

const InfoModal = ({ closeModal }: IProps) => {
  const modalClassNames = classnames(
    'fds-c-modal fds-c-modal__section',
    styles.hostedModal
  )
  const buttonWrapperClassName = classnames(
    'fds-u-text-align-center',
    styles.buttonWrapper
  )
  const buttonClassName = classnames(
    'fds-c-button--3d -color-primary -size-m',
    styles.modalButton
  )
  const footerTextClassName = classnames(
    'fds-u-text-align-center',
    styles.footerText
  )

  return (
    <div className={modalClassNames}>
      <div className={styles.hostedModalContainer}>
        <h2 className={styles.modalHeader}>
          Included with your Envato Hosted plan
        </h2>

        <ul className={styles.iconList}>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Instant setup of WordPress and your selected theme
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Fully managed and secured WordPress hosting, including: WordPress
              core upgrades, server security, site monitoring and daily backups
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Dedicated support from our team of WordPress experts
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Custom Site Setup services for yearly customers
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Amazon AWS infrastructure, with 99.9% uptime
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Migration of an existing WordPress site
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Assistance with purchasing or transferring a domain
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Discounted freelancer services for the life of your plan
            </div>
          </li>
          <li className={styles.iconItem}>
            <CheckIcon className={styles.checkIcon} />
            <div className={styles.itemText}>
              Up to 100,000 monthly visits, 5GB of disk space, and 100GB of
              monthly bandwidth
            </div>
          </li>
        </ul>

        <p className={buttonWrapperClassName}>
          <button className={buttonClassName} onClick={closeModal}>
            OK, got it!
          </button>
        </p>

        <p className={footerTextClassName}>
          Got further questions? Check out our&nbsp;
          <a href="https://envatohosted.zendesk.com/hc/en-us/sections/115000917665-FAQ">
            Envato Hosted FAQs
          </a>!
        </p>
      </div>
    </div>
  )
}

export default InfoModal
